<template>
  <div v-if="showBlock" class="pwa-install" :class="`tone-${tone}`">
    <p v-if="installed && tone === 'settings'" class="pwa-status">
      {{ t('pwa.installed') }}
    </p>
    <template v-else-if="canPrompt">
      <button type="button" class="pwa-btn" @click="install()">
        {{ t('pwa.install') }}
      </button>
      <p v-if="tone === 'settings'" class="pwa-hint">{{ t('pwa.hint') }}</p>
    </template>
    <p v-else-if="showIosHint" class="pwa-hint">
      {{ t('pwa.ios') }}
    </p>
    <p v-else-if="tone === 'settings'" class="pwa-hint">
      {{ t('pwa.manual') }}
    </p>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { usePwaInstall } from '../composables/usePwaInstall'
import { useI18n } from '../i18n/t'

const props = withDefaults(
  defineProps<{
    tone?: 'settings' | 'home' | 'drawer'
  }>(),
  { tone: 'settings' },
)

const { t } = useI18n()
const { installed, canPrompt, showIosHint, visible, install } = usePwaInstall()

const showBlock = computed(() => {
  if (props.tone === 'settings') return true
  return visible.value
})
</script>

<style scoped>
.pwa-install {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
}

.pwa-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 40px;
  padding: 0 20px;
  border: 0;
  border-radius: 20px;
  background: var(--md-sys-color-primary);
  color: var(--md-sys-color-on-primary);
  font: inherit;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
}

.pwa-btn:hover {
  filter: brightness(1.06);
}

.pwa-hint,
.pwa-status {
  margin: 0;
  color: var(--md-sys-color-on-surface-variant);
  font-size: 13px;
  line-height: 18px;
}

.tone-drawer {
  width: 100%;
}

.tone-drawer .pwa-btn {
  width: 100%;
}

.tone-home .pwa-btn {
  margin-top: 4px;
}
</style>
